import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=cbb9b400&scoped=true"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditor.vue?vue&type=style&index=0&id=cbb9b400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb9b400",
  null
  
)

export default component.exports